var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleList',{attrs:{"emphasized-text":"Popular Routes","main-list":_vm.itemData,"is-show-in-percent":_vm.isGlobalPercent}})
}
var staticRenderFns = []

export { render, staticRenderFns }